import React from "react";

import "./Toolbar.css";

const Toolbar = (props) => <div className="toolbar">{props.children}</div>;

export default Toolbar;
